import { render, staticRenderFns } from "./ProductMediaDesktop.vue?vue&type=template&id=17edd4df&scoped=true&"
import script from "./ProductMediaDesktop.vue?vue&type=script&lang=js&"
export * from "./ProductMediaDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ProductMediaDesktop.vue?vue&type=style&index=0&id=17edd4df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17edd4df",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyVideo: require('/app/components/UI/UiLazyVideo.vue').default,UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default,UiSpinner: require('/app/components/UI/UiSpinner.vue').default})
